import { getCoffreSuiteApiBase } from "@/auth/paths";
import { mailAuthHeaders } from "@/auth/session";

export const MAIL_COFFRE_UNLOCKED_EVENT = "mail-coffre-unlocked";

export class CoffreUnlockDenied extends Error {
  readonly code: string;
  constructor(code: string, message: string) {
    super(message);
    this.name = "CoffreUnlockDenied";
    this.code = code;
  }
}

const unlockWaiters = new Set<() => void>();
let unlockAsked = false;

export function onCoffreUnlockAsk(listen: () => void): () => void {
  unlockWaiters.add(listen);
  if (unlockAsked) listen();
  return () => {
    unlockWaiters.delete(listen);
  };
}

export function requestCoffreUnlock(): void {
  unlockAsked = true;
  unlockWaiters.forEach((listen) => listen());
}

export function coffreUnlockClosed(): void {
  unlockAsked = false;
}

/** Même durée que le Coffre (1 h, 1 jour ou 1 semaine). Défaut : une heure. */
function coffreSessionSeconds(): number {
  try {
    const raw = localStorage.getItem("coffre_session_extend");
    if (!raw) return 3600;
    const idle = Number((JSON.parse(raw) as { idleSeconds?: number }).idleSeconds);
    if (idle === 3600 || idle === 86400 || idle === 604800) return idle;
  } catch {
    /* une heure */
  }
  return 3600;
}

export async function unlockCoffreVault(password: string): Promise<void> {
  let data: { success?: boolean; error?: string; message?: string } = {};
  let ok = false;
  try {
    const res = await fetch(`${getCoffreSuiteApiBase()}/coffre-unlock.php`, {
      method: "POST",
      credentials: "include",
      cache: "no-store",
      headers: {
        ...mailAuthHeaders(),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        password,
        session_extend_seconds: coffreSessionSeconds(),
      }),
    });
    data = (await res.json().catch(() => ({}))) as typeof data;
    ok = res.ok && data.success !== false;
  } catch {
    ok = false;
  }
  if (!ok) {
    throw new CoffreUnlockDenied(
      typeof data.error === "string" ? data.error : "invalid_password",
      data.message || "Mot de passe maître refusé."
    );
  }
  unlockAsked = false;
}
